const deleteDealGroupDenied = {
    title: 'Ошибка удаления',
    description: 'Нельзя удалить воронку, если в ней есть <b>хотя бы одна</b> сделка',
    mode: 'denied',
} as const;

export default deleteDealGroupDenied;
